import React, {useCallback, useState} from "react";
import {InvoiceFileResponse} from "../../../../Api/data/invoice/types";
import {useKeycloak} from "@react-keycloak/web";
import {deleteInvoiceAttachment, getAllInvoiceAttachments} from "../../../../Api/data/invoice/client";
import CrudList, {
    CrudListConfiguration,
    ICrudListProps,
    SelectMode
} from "../../../../Crudder/components/CrudList/CrudList";
import {dateFormatter, dateTimeFormatter, fileSizeFormatter} from "../../../../Crudder/utils/utils";
import {downloadFile} from "../../../../Api/data/file/client";
import {Link} from "@material-ui/core";
import Button from "@mui/material/Button";



interface IInvoiceFileListProps {
    invoiceID: number;
    crudListProps?: Partial<CrudListConfiguration<InvoiceFileResponse>>
}

const InvoiceFileList: React.FC<IInvoiceFileListProps> = ({invoiceID, crudListProps}) => {

    const [ data, setData ] = useState<InvoiceFileResponse[]>([]);


    const { keycloak, initialized: keycloakInitialized } = useKeycloak();

    const fetchData = useCallback(() => {
        return new Promise<InvoiceFileResponse[]>((resolve, reject) => {
            getAllInvoiceAttachments(invoiceID).then((data) => {
                setData(data);
                resolve(data)
            })
        });
    }, []);

    const handleDelete: (values: number) => Promise<void> = useCallback((id: number) => {
        return new Promise<void>((resolve, reject) => {
            deleteInvoiceAttachment(invoiceID, id).then((response) => {
                resolve();
            })
        });
    }, []);
    //
    // const getDetail = useCallback((id) => {
    //     return new Promise<any>((resolve, reject) => {
    //         resolve(data.find(i => i.InvoiceID == id));
    //     });
    // }, [data]);


    return (
            <CrudList<InvoiceFileResponse>
                config={{
                    title: "Seznam souborů",
                    getRowID: (file) => file.invoiceFileID,
                    disableAdd: true,
                    hideHeader: true,
                    disableEdit: crudListProps?.disableEdit || crudListProps?.selectMode != SelectMode.NONE,
                    disableRemove: crudListProps?.disableRemove || crudListProps?.selectMode != SelectMode.NONE,
                    selectMode: crudListProps?.selectMode,
                    ...crudListProps
                }}
                itemFields={[
                    {
                        name: "name",
                        title: "Název",
                        columnDef: {
                            flex: 4,
                            renderCell: params => {
                                // params.row.
                                return (
                                    <Link component={Button} color={"inherit"} onClick={() => {
                                        downloadFile(params.row.fileID);
                                    }}>
                                        {params.value}
                                    </Link>
                                )
                            }
                        },
                    },
                    {
                        name: "createdDate",
                        title: "Vytvořeno",
                        columnDef: {
                            flex: 1,
                            valueFormatter: dateTimeFormatter
                        },
                    },
                    {
                        name: "size",
                        title: "Velikost",
                        columnDef: {
                            flex: 1,
                            valueFormatter: fileSizeFormatter
                        },
                    },
                    {
                        name: "mimeType",
                        title: "Typ",
                        columnDef: {
                            hide: true,
                            flex: 2
                        },
                    },
                ]}
                data={fetchData}
                onDelete={handleDelete}
            />
    );
};

export default InvoiceFileList;